import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "18",
  viewBox: "0 0 17 18",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.364 9.028c.002-.12.019-.24.05-.36l1.554-5.795a1.5 1.5 0 1 1 2.897.776l-.51 1.908c.084-.01.169-.017.253-.022l4.82-4.819a1 1 0 1 1 1.414 1.414L7.876 6.096l-.183.183a.5.5 0 0 0 .707.707l.35-.35 4.954-4.953a1 1 0 1 1 1.414 1.414l-4.845 4.845-.458.458a.5.5 0 0 0 .707.707l.434-.434 3.137-3.137a1 1 0 0 1 1.414 1.414L12.12 10.34l-.89.89a.5.5 0 1 0 .707.707l.59-.591 1.885-1.884a1 1 0 0 1 1.414 1.414l-5.354 5.354-.067-.067c-2.479 1.767-5.824 1.644-7.91-.442-1.76-1.76-2.122-4.416-1.13-6.692z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-interpreting"}) } }